import { defineMessages } from 'react-intl';

export default defineMessages({

  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What Expenses are you claiming for?',
  },
  thisSectionRelatesToExpensesForYourBaggagePersonalItemsCashAndTravelDocuments: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.thisSectionRelatesToExpensesForYourBaggagePersonalItemsCashAndTravelDocuments',
    defaultMessage: 'This section relates to expenses for your baggage, personal items, cash and travel documents.',
  },
  thisSectionRelatesToExpensesForYourBaggage: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.thisSectionRelatesToExpensesForYourBaggage',
    defaultMessage: 'This section relates to expenses for your baggage and personal items.',
  },
  whatHappenedToYourBaggageAndPersonalItems: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.whatHappenedToYourBaggageAndPersonalItems',
    defaultMessage: 'What happened to your baggage and personal items?',
  },
  baggageDelay: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.baggageDelay',
    defaultMessage: 'Baggage delay',
  },
  lostStolenOrDamagedItems: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.lostStolenOrDamagedItems',
    defaultMessage: 'Lost, stolen or damaged items',
  },
  hasYourBaggageBeenReturnedToYou: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.hasYourBaggageBeenReturnedToYou',
    defaultMessage: 'Has your baggage been returned to you?',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  whatItemsAreYouClaimingFor: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.whatItemsAreYouClaimingFor',
    defaultMessage: 'What items are you claiming for?',
  },
  essentialMedication: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.essentialMedication',
    defaultMessage: 'Essential medication',
  },
  jewelleryOrTraditionalWatches: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.jewelleryOrTraditionalWatches',
    defaultMessage: 'Jewellery or traditional watches',
  },
  laptopsTabletsOrCameras: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.laptopsTabletsOrCameras',
    defaultMessage: 'Laptops, tablets or cameras',
  },
  mobilephonesLaptopsTabletsOrCameras: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.mobilephonesLaptopsTabletsOrCameras',
    defaultMessage: 'Laptops, mobile phones, tablets or cameras',
  },
  otherUnspecifiedItems: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.otherUnspecifiedItems',
    defaultMessage: 'Other unspecified items',
  },
  specifiedHighValueItems: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.specifiedHighValueItems',
    defaultMessage: 'Specified high value items',
  },
  bankCardsOrTravelDocuments: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.bankCardsOrTravelDocuments',
    defaultMessage: 'Bank cards or travel documents',
  },
  cash: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.cash',
    defaultMessage: 'Cash',
  },
  expenseFor: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfExpense: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  dateOfExpenses: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
  amountClaimed: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  currency: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.currency',
    defaultMessage: 'Currency',
  },
  haveYouReceivedReimbursement: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received Reimbursement?',
  },
  dateReimbursementReceived: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },
  fromWhom: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.fromWhom',
    defaultMessage: 'If so, from whom?',
  },
  estimatedValue: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.estimatedValue',
    defaultMessage: 'Actual Cost',
  },
  howMuch: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.howMuch',
    defaultMessage: 'How much?',
  },
  costOfReplacement: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.costOfReplacement',
    defaultMessage: 'Cost of Replacement',
  },
  originalCost: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.originalCost',
    defaultMessage: 'Original Cost',
  },
  dateOfPurchase: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.dateOfPurchase',
    defaultMessage: 'Date Of Purchase',
  },
  depreciationType: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.depreciationType',
    defaultMessage: 'Depreciation Type',
  },
  isRequired: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  addItem: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.addItem',
    defaultMessage: 'Add Expense',
  },
  itemWithIdx: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },
  yes: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.no',
    defaultMessage: 'No',
  },
  areYouClaimingForASpecifiedItem: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.areYouClaimingForASpecifiedItem',
    defaultMessage: 'Are you claiming for a Specified Item?',
  },
  pleaseSelectTheItemYouAreClaimingFor: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.pleaseSelectTheItemYouAreClaimingFor',
    defaultMessage: 'please Select The Item You Are Claiming For:',
  },
  itemType: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.itemType',
    defaultMessage: 'Item Type',
  },
  descriptionOfValuables: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.descriptionOfValuables',
    defaultMessage: 'Description Of Valuables',
  },
  amountAUD: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.amountAUD',
    defaultMessage: 'Amount (AUD)',
  },
  amountUSD: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.amountUSD',
    defaultMessage: 'Amount (NZD)',
  },
  dateOfIncident: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.dateOfIncident',
    defaultMessage: 'Date Of Incident',
  },
  selectInsuredForExpense: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.selectInsuredForExpense',
    defaultMessage: 'Select the Insured(s) for the expense',
  },
  amountClaimExceedsMaximumDigits: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.amountClaimExceedsMaximumDigits',
    defaultMessage: 'Amount Claimed exceeds the maximum allowable digits. Please enter a valid claim amount.',
  },
  descriptionMaxLength: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.descriptionMaxLength',
    defaultMessage: 'Please enter maximum of 150 characters',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.BaggageAndPersonalItems/messages.js